import $ from 'jquery';

export default function payment() {
  var status_check = $('#status-check');
  if (status_check.length > 0) {
    var id = status_check.attr('paymentId');
    var timer = setInterval(function() {
      $.getJSON("/payments/status_check/" + id, function(data) {
        if ($.inArray(data.result, ['success', 'failure']) !== -1) {
          clearInterval(timer);
          window.location = data.url;
        }
      });
    }, 5000);
  }

  $('#paymentsTable').DataTable({
    order: [[4, 'desc']],
    language: {
      processing: 'Przetwarzanie...',
      search: 'Szukaj:',
      lengthMenu: 'Pokaż _MENU_ pozycji',
      info: 'Pozycje od _START_ do _END_ z _TOTAL_ łącznie',
      infoEmpty: 'Pozycji 0 z 0 dostępnych',
      infoFiltered: '(filtrowanie spośród _MAX_ dostępnych pozycji)',
      infoPostFix: '',
      loadingRecords: 'Wczytywanie...',
      zeroRecords: 'Nie znaleziono pasujących pozycji',
      emptyTable: 'Brak danych',
      paginate: {
        first: 'Pierwsza',
        previous: 'Poprzednia',
        next: 'Następna',
        last: 'Ostatnia'
      },
      aria: {
        sortAscending: ': aktywuj, by posortować kolumnę rosnąco',
        sortDescending: ': aktywuj, by posortować kolumnę malejąco'
      }
    }
  });
};
